import React, {Component} from 'react';
import CBaseComponent from '@/components/CBaseComponent'
import { connect} from 'react-redux'
import './index.scss'
import {Card, Modal, Button, message,Empty} from "antd";
import {bindActionCreators, compose} from "redux";
import { withRouter} from 'react-router-dom'
import { useEffect, useRef } from "react";
import ReactApexChart from "react-apexcharts";
import {
    collapsedToggle,
    setWindowInfo,
    setUserInfo,
    setCurrentTheme,
    setMenu,
    setYear,
    setUserList
} from "../../redux/common/action";
import { submitdata, resetdata,selectIndex } from "@/servers/commonApi";

@CBaseComponent
class Home extends Component{
    constructor(props) {
        super(props);
        this.showModal = this.showModal.bind(this)
        this.handleCanceldialog = this.handleCanceldialog.bind(this)
        this.downloads = this.downloads.bind(this)
    }


    state = {
        data: null,
        loading: false,
        isModalVisible: false,
        status: false,
        indexdata:[],
        fileslist:[],
        newslist:[],
        result:{},
        title:'',
        content:'',
        name: '',
        time:'',
        series: [],
        options: {
            xaxis: {
                categories: [],
                labels: {
                    show: true,
                    rotate: 90,
                }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return val;
                    }
                }
            },
            chart: {
                type: 'bar',
                stacked: true,
                stackType: '100%'
            },
            dataLabels: {
                enabled: true,
                offsetY: 20,
                style: {
                    fontSize: '10px',
                    colors: ["#304758"]
                },
                // formatter: function (val) {
                //     return Math.round(val*2) + "%";
                // }
            },
            title: {
                text: '各二级指标得分情况'
            },
            fill: {
                opacity: 1
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetY: 0
                    }
                }
            }],
        },
    };

    showModal(data){
        this.setState({
            isModalVisible:true
        })
        var newStr = decodeURI(data.content).replaceAll("++++","\n");
        this.setState({
            title:data.title,
            name: data.postedby,
            time:data.postedtime,
            content:newStr
        })
    }

    async handleCancel(){
        Modal.confirm({
            content: '确认撤回?',
            okText: '确认',
            cancelText: '取消',
            onOk:()=>{
                 resetdata().then(res=>{
                    if (res.statecode === 0) {
                        message.success('撤销成功');
                        this.selectdata()
                        this.setState({
                            status: true
                        })
                    } else {
                        message.error(res.statemessage);
                    }
                })
            }
        })
    }

    handleCanceldialog(){
        this.setState({
            title: '',
            content:'',
            isModalVisible: false
        })
    }

    downloads(data){
        window.open(data,"_blank");
    }

    handleSubmit(){
        Modal.confirm({
            content: '确认提交?',
            okText: '确认',
            cancelText: '取消',
            onOk:()=>{
                 submitdata().then(res=>{
                    if (res.statecode === 0) {
                        message.success('提交成功');
                        this.selectdata()
                        this.setState({
                            status: true
                        })
                    } else {
                        message.error(res.statemessage);
                    }
                })
            }
        })
    }

    changeitem(data){
        data.forEach(item=>{
            item.showids = item.id
            if (item.children){
                this.changeitem(item.children)
            }
        })
        return data
    }

    componentWillReceiveProps(nextProps){

    }

     selectdata(){
        this.setState({
            loading:true
        })
        selectIndex().then(res=>{
            if (res.statecode === 0) {
                this.setState({
                    result:res.records[0],
                    fileslist:res.records[0].filelist,
                    newslist:res.records[0].bulletinlist,
                    loading:false,
                    series:res.records[0].series,
                    options:{...this.state.options, xaxis:{
                            categories:res.records[0].xaxis.categories
                        }}
                })
            } else {
                message.error(res.statemessage);
            }
        })
    }

    componentDidMount(){
        this.selectdata()
    }


    render(){
        return (
            <main style={{textAlign:'left'}} className='containerblock'>
                <div className='contents'>
                    <div className='zhibiao'>
                        <span>当前进展：{this.state.result.step}</span>
                        <div className='operate-name'>
                            {this.state.result.appform !== '' && <div className='links' onClick={()=>{this.downloads(this.state.result.appform)}}>博物馆定级评估申请书</div>}
                            {this.state.result.submitlabel?this.state.result.submitlabel === '确认提交'?
                                    <Button type="primary" className='c-button' onClick={()=>{this.handleSubmit()}}>
                                        确认提交
                                    </Button>:<Button type="primary" className='c-button' onClick={()=>{this.handleCancel()}}>
                                        撤回
                                    </Button>:''}
                        </div>
                    </div>
                    <div className='system-info'>
                        <div className='system-tz'>
                            <Card title="系统公告" bordered={false} style={{ width: '100%' }}>
                                {
                                    this.state.newslist.length === 0? <Empty></Empty>:
                                        this.state.newslist.map(item=>{
                                            return <div onClick={()=>{this.showModal(item)}} className='new-block'>
                                                {
                                                    Number(item.top > 1000) ?
                                                        <span className='important'>{item.title}</span>:
                                                        <span>{item.title}</span>
                                                }
                                                <span>{item.postedtime}</span>
                                            </div>
                                        })
                                }

                            </Card>
                        </div>
                        <div className='system-file'>
                            <Card title="文件中心" bordered={false} style={{ width: '100%' }}>
                                {
                                    this.state.fileslist.length === 0? <Empty></Empty>:
                                        this.state.fileslist.map(item=>{
                                            return <div onClick={()=>{this.downloads(item)}} className='new-block'>
                                                <a href={item.fileurl} style={{color:'rgb(60, 185, 241)'}}>{item.title}</a >
                                            </div>
                                        })
                                }
                            </Card>
                        </div>
                    </div>
                    {JSON.stringify(this.state.result) !== '{}' &&
                        <div id="chart" style={{marginTop:'20px'}}>
                            <ReactApexChart options={this.state.options} series={this.state.series} type="bar"  height={400}/>
                        </div>
                    }

                </div>
                <Modal title={this.state.title}
                       visible={this.state.isModalVisible}
                       onCancel={this.handleCanceldialog}
                       centered={true}
                       footer={[
                           <Button key="submit" type="primary" onClick={this.handleCanceldialog}>
                               取消
                           </Button>
                       ]}
                >
                    <div style={{marginTop:'-10px',textAlign:'center',marginBottom:'10px'}}><span style={{marginRight:'10px'}}>{this.state.name}</span><span>{this.state.time}</span></div>
                    <div style={{whiteSpace: 'pre-wrap'}}>{this.state.content}</div>
                </Modal>
            </main>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        breadcrumbData: state.breadcrumbData,
        collapsed: state.collapsed,  // 侧边栏是否展开
        windowInfo: state.windowInfo,
        userInfo: state.userInfo,
        userList:  state.userList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        collapsedToggle: bindActionCreators(collapsedToggle, dispatch),
        setWindowInfo: bindActionCreators(setWindowInfo, dispatch),
        setUserInfo: bindActionCreators(setUserInfo, dispatch),
        setCurrentTheme: bindActionCreators(setCurrentTheme, dispatch),
        setUserList: bindActionCreators(setUserList, dispatch),
        setMenu:bindActionCreators(setMenu,dispatch),
        setYear:bindActionCreators(setYear,dispatch)
    };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Home);
